import React from 'react';
import cx from 'classnames';
import { Button, Form, Input } from 'semantic-ui-react';


type HeaderSearchFormProps = {
  inputId: string;
  autoFocus?: boolean;
  className?: string;
  onEscape?: () => void;
  onSubmit?: () => void;
};

const HeaderSearchForm: React.FC<HeaderSearchFormProps> = ({
  inputId,
  autoFocus = false,
  className,
  onEscape,
  onSubmit,
}) => {
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (autoFocus) {
      inputRef.current?.focus();
    }
  }, [autoFocus]);

  return (
    <Form
      className={cx('site-search', className)}
      action="/search"
      method="get"
      role="search"
      onSubmit={onSubmit}
    >
      <label className="site-search__label" htmlFor={inputId}>
        Search
      </label>

      <Input fluid action className="site-search__control">
        <input
          ref={inputRef}
          id={inputId}
          className="site-search__input"
          type="search"
          name="SearchableText"
          placeholder="Search..."
          aria-label="Search"
          onKeyDown={(event) => {
            if (event.key === 'Escape') {
              onEscape?.();
            }
          }}
        />

        <Button className="site-search__submit" type="submit">
          Search
        </Button>
      </Input>
    </Form>
  );
};

export default HeaderSearchForm;
